define("shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/switch-business-instagram/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p>{{t "onboarding.side_wiz.general.set_up_auto_publishing.subcopy2_1"}}</p>
  <p>
    <Shared::Link
      @href="https://help.later.com/hc/en-us/articles/360042770474"
      @text={{t "onboarding.side_wiz.general.set_up_auto_publishing.link"}}
      {{track "clicked-help-ig-business-profile-switch" "click"}}
    />
  </p>
  <p>
    {{html-safe
      (t "onboarding.side_wiz.general.set_up_auto_publishing.subcopy2_2" username=@socialProfile.displayNickname)
    }}
  </p>
  <p>{{html-safe (t "onboarding.side_wiz.general.set_up_auto_publishing.subcopy2_3")}}</p>
  */
  {
    "id": "V6395aXd",
    "block": "[[[10,2],[12],[1,[28,[35,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.subcopy2_1\"],null]],[13],[1,\"\\n\"],[10,2],[12],[1,\"\\n  \"],[8,[39,1],[[4,[38,2],[\"clicked-help-ig-business-profile-switch\",\"click\"],null]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/360042770474\",[28,[37,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.link\"],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\"],[10,2],[12],[1,\"\\n  \"],[1,[28,[35,3],[[28,[37,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.subcopy2_2\"],[[\"username\"],[[30,1,[\"displayNickname\"]]]]]],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,2],[12],[1,[28,[35,3],[[28,[37,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.subcopy2_3\"],null]],null]],[13]],[\"@socialProfile\"],false,[\"t\",\"shared/link\",\"track\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/switch-business-instagram/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});